import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { ViewController, NavParams, Events } from 'ionic-angular';

// Providers
import { ProvidersService } from '../../providers/providers/providers-service';
import { InstructorsService } from '../../providers/instructors/instructors-service';
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  templateUrl: 'employer.modal.html'
})

export class EmployerModalPage
{
  providers: any = [];
  instructor: any = {};
  searchResults: boolean = false;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public providersService: ProvidersService,
    public helperService: HelperService,
    public instructorsService: InstructorsService,
    public events: Events
  ) {
    this.viewCtrl = viewCtrl;
    let instructors = this.navParams.get('instructors');
    this.instructor = instructors[0];
  }

  addProviderToInstructor( provider )
  {
    let data = {
      instructor_id: this.instructor.instructor_id,
      provider_id: provider.provider_id
    }
    this.instructorsService.addProviderToInstructor( data ).subscribe( employer_record => {
      this.events.publish('app:log', {
        message: 'Instructor employer entry saved.',
        status: 'success',
        type: 'save instructor employer'
      });

      let employer:any = employer_record;
      // Get provider record
      this.providersService.getProvider( data.provider_id ).subscribe( provider_record => {
        employer.provider_record = provider_record;
        this.instructor.employers.push( employer );
        this.dismissModal();
      });
    },
    error => {
      this.helperService.showErrors( error );
    });
  }

  searchProviders( ev )
  {
    let search_term = ev.target.value;

    if ( search_term && search_term.length > 3 )
    {
      // Clear this.providers array to prep for search results.
      this.providers.length = 0;

      this.providersService.searchProviders(search_term).subscribe(data => {
        this.searchResults = true;
        this.providers = data;

        if ( this.providers.length === 0 )
        {
          this.searchResults = false;
        }
      });
    } else {
    }
  }

  clearSearch( ev )
  {
    this.providers.length = 0;
    this.searchResults = false;
  }

  dismissModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/employer.modal.ts